import * as React from "react";
import { ConfigFieldTextArea } from "../../forms/informedv4/ConfigFieldTextAreaV4";
import { ConfigFieldTextBox } from "../../forms/informedv4/ConfigFieldTextBoxV4";
import { ConfigFieldDropdown } from "../../forms/informedv4/ConfigFieldDropdownV4";
import { Dropdown } from "../../forms/informedv4/DropdownV4";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useReferenceContextProvider } from "../../Core/ReferenceContextProvider";
import { ConfigurableDataItemIds } from "../../misc/api/ApiConfigurableDataItems";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { useFormApi } from "informedv4";

export interface SiteFormModel {
    Id: string;
    SiteId: string;
    Name: string;
    Address: string;
    Country: string;
    TimeZone: string;
    Contact: string;
    Email: string;
    Phone: string;
}

export const SiteFormBody = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const { timeZones } = useReferenceContextProvider();
    const [countries, setCountries] = React.useState([]);
    const client = useWebPortalApiClient();
    const formApi = useFormApi();
    const [countriesLoaded, setCountriesLoaded] = React.useState(false);

    React.useEffect(() => {
        const getCountries = async () => {
            const studyCountries = await client.client.getStudyCountries('countryCode,name', `studyId eq ${study.id}`, 'name');
            setCountries(studyCountries.value);
            setCountriesLoaded(true);
        };

        getCountries();

        return () => {
            client.abortController.abort();
        }
    }, [study.id]);

    React.useEffect(() => {
        if (!formApi) return;
        if (!countriesLoaded) return;

        const current = formApi.getValue?.("Country");
        const isValid = current != null && countries.some((c) => c.countryCode === current);

        if (!isValid) {
            formApi.setValue("Country", "");
        }
    }, [countriesLoaded, countries, formApi])

    return (
        <>
            <div className="row">
                <ConfigFieldTextBox
                    name="SiteId"
                    id="SiteId"
                    field="SiteId"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteNumber}
                />
                <ConfigFieldTextBox
                    name="Name"
                    id="Name"
                    field="Name"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteName}
                />
                <ConfigFieldTextBox
                    name="Contact"
                    id="Contact"
                    field="Contact"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteInvestigator}
                />
            </div>
            <div className="row">
                <ConfigFieldTextArea
                    name="Address"
                    id="Address"
                    field="Address"
                    className="col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteAddress}
                />
                <ConfigFieldDropdown
                    name="Country"
                    id="Country"
                    field="Country"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteCountry}
                >
                    {countries.map(c => (<option key={`Option${c.countryCode}`} value={c.countryCode}>{c.name}</option>))}
                </ConfigFieldDropdown>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="TimeZone">Time Zone</label>
                    <Dropdown
                        name="TimeZone"
                        id="TimeZone"
                        field="TimeZone"
                        required={true}
                    >
                        <option key="OptionBlank"></option>
                        {timeZones.map(c => (<option key={`Option${c.id}`} value={c.id}>{c.name}</option>))}
                    </Dropdown>
                </div>

            </div>
            <div className="row">
                <ConfigFieldTextBox
                    name="Email"
                    id="Email"
                    field="Email"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SiteEmail}
                />
                <ConfigFieldTextBox
                    name="Phone"
                    id="Phone"
                    field="Phone"
                    className="form-group col-md-4 col-sm-4 col-xs-12"
                    validated={true}
                    required={true}
                    itemId={ConfigurableDataItemIds.SitePhone}
                />
            </div>
        </>
    );
}
